import { render } from "./MediaSizer.vue?vue&type=template&id=177524da&ts=true"
import script from "./MediaSizer.vue?vue&type=script&lang=ts"
export * from "./MediaSizer.vue?vue&type=script&lang=ts"

import "./MediaSizer.vue?vue&type=style&index=0&id=177524da&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__